/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUpdateFacilityServiceAreasResponse
 */
export interface BulkUpdateFacilityServiceAreasResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateFacilityServiceAreasResponse
     */
    updated: number;
}

/**
 * Check if a given object implements the BulkUpdateFacilityServiceAreasResponse interface.
 */
export function instanceOfBulkUpdateFacilityServiceAreasResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function BulkUpdateFacilityServiceAreasResponseFromJSON(json: any): BulkUpdateFacilityServiceAreasResponse {
    return BulkUpdateFacilityServiceAreasResponseFromJSONTyped(json, false);
}

export function BulkUpdateFacilityServiceAreasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateFacilityServiceAreasResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updated': json['updated'],
    };
}

export function BulkUpdateFacilityServiceAreasResponseToJSON(value?: BulkUpdateFacilityServiceAreasResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updated': value.updated,
    };
}

